import Box from "@mui/material/Box";
import JsonEditor from "lib/jsoneditor";
import { FormField } from "../../types";
import type { JsonAssocValue, SetupValueProps } from "../types";

const JsonAssoc = ({
    values,
    onChange
}: SetupValueProps<JsonAssocValue>) => (
    <Box
        sx={{
            gridColumn: 'span 2'
        }}
    >
        <JsonEditor
            value={values[FormField.SetupValue].value}
            onChange={onChange}
        />
    </Box>
);

export default JsonAssoc;
